import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NbToastrService } from '@nebular/theme';
import { TranslateService } from "@ngx-translate/core";
import { MastersService } from "src/app/core/services/masters";
import { LoginService } from "src/app/core/services/login";
import { MODAL_DIALOG_TYPES } from 'src/app/core/utils/modal-dialog-types';
import { ModalSchedulesComponent } from "../modal-schedules/modal-schedules.component";
import { ModalStructureComponent } from "../modal-structure/modal-structure.component";
import { finalize, forkJoin } from 'rxjs';
import { ReportService } from 'src/app/core/services/report/report.service';
import { ChatAssistantComponent } from '../chat-assistant/chat-assistant.component';
import { Profiles } from 'src/app/core/utils/profiles.enum';
import { Utils } from 'src/app/core/utils/utils';
import { CenterService } from 'src/app/core/services/center/center.service';
import { ModalAceptarCancelarComponent } from '../modal';
import { TableInformeComponent } from 'src/app/pages/table-informe/table-informe.component';
import { User } from 'src/app/core/models/users/user.models';
import { TableInformeIndividualComponent } from 'src/app/pages/table-informe-individual/table-informe-individual.component';
import { ModalCreateStructureComponent } from '../modal-create-structure/modal-create-structure.component';
import { ModalTutorialManagerComponent } from '../modal-tutorial-manager/modal-tutorial-manager.component';
import { InformeAdminComponent } from './informe-admin/informe-admin.component';
import { SecondStepAdminComponent } from './second-step-admin/second-step-admin.component';
import { ModalReportingContentAdminComponent } from '../modal-reportingContent-admin/modal-reportingContent-admin.component';
import { ModalResumenActivityComponent } from './modal-resumen-activity/modal-resumen-activity.component';
import { InventarioMandosComponent } from './inventario-mandos/inventario-mandos.component';
import { ModalAiUsageStatsComponent } from './modal-ai-usage-stats/modal-ai-usage-stats.component';
import { EstudioCientificoComponent } from './estudio-cientifico/estudio-cientifico.component';

@Component({
	selector: "app-control-panel-admin",
	templateUrl: "./control-panel-admin.component.html",
	styleUrls: ["./control-panel-admin.component.scss"],
	encapsulation: ViewEncapsulation.None,
	standalone: false
})
export class ControlPanelAdminComponent implements OnInit {
	user: User;
	selectedGroupInfo: any;
	initialData: any;
	//variables profesores
	teachersRegistered = 0;
	teachersRegisteredLastMonth = 0;
	teachersOnlineLastWeek = 0;
	//variables estudiantes
	studentsRegistered = 0;
	studentsRegisteredLastMonth = 0;
	studentsOnlineLastWeek = 0;
	//variables editores
	editorsRegistered = 0;
	editorsRegisteredLastMonth = 0;
	editorsOnlineLastWeek = 0;
	//variables grupos
	groupsTotal = 0;
	groupsAverageStudentsPerGroup = 0.0;
	//variables proyectos
	projectsTotal = 0;
	projectsCreatedLastMonth = 0;
	projectsUsedLastWeek = 0;
	//variables padres
	parentsRegistered = 0;
	parentsRegisteredLastMonth = 0;
	parentsOnlineLastWeek = 0;
	//variables asignaturas
	subjectsTotal = 0;
	//variables centros
	centersTotal = 0;
	//variables centros estudio cientifico
	estudioCientificoCentersTotal = 0;

	isNavigating = false;

	assignedCenter: any;

	constructor(
		public activeModal: NgbActiveModal,
		private translateService: TranslateService,
		private modalService: NgbModal,
		public loginService: LoginService,
		private mastersService: MastersService,
		private reportService: ReportService,
		private utils: Utils,
		private centerService: CenterService,
		private toastrService: NbToastrService
	) { }

	ngOnInit() {
		this.user = this.loginService.getUser();
		localStorage.removeItem("selectedGroupInfo");
		this.cargarDatosIniciales();
	}

	ngOnDestroy() { }

	closeModal(sendData?: any) {
		this.activeModal.close();
	}

	//============================================
	//========== DATOS INICIALES ==========

	cargarDatosIniciales() {
		this.reportService.datosInicialesPanelControlAdmin().subscribe(res => {
			if (res) {
				this.initialData = res.data;
			}
		})
	}

	//=========================================================
	//========== FUNCIONES BOTONES SUPERIORES ==========

	openTable() {
		if (this.isNavigating) return;
		this.isNavigating = true;
		setTimeout(() => { this.isNavigating = false }, 300);
		this.modalService.open(TableInformeComponent, {
			scrollable: false,
			windowClass: `${MODAL_DIALOG_TYPES.W90} h-100`,
		});
		//*** Creamos el log ***
		this.mastersService.createActivityHistory(
			"globales",
			"Ha entrado en el menú de Globales."
		);
		//*** Fin del log ***
	}

	openTableIndividual() {
		if (this.isNavigating) return;
		this.isNavigating = true;
		setTimeout(() => { this.isNavigating = false }, 300);
		this.modalService.open(TableInformeIndividualComponent, {
			scrollable: true,
			windowClass: `${MODAL_DIALOG_TYPES.W90} h-100`,
		});
		//*** Creamos el log ***
		this.mastersService.createActivityHistory(
			"individuales",
			"Ha entrado en el menú de Individuales."
		);
		//*** Fin del log ***
	}

	openModalStructure() {
		if (this.isNavigating) return;
		this.isNavigating = true;
		setTimeout(() => { this.isNavigating = false }, 300);
		this.modalService.open(ModalCreateStructureComponent, {
			scrollable: true,
			windowClass: `${MODAL_DIALOG_TYPES.W70} h-100`,
		});
		//*** Creamos el log ***
		this.mastersService.createActivityHistory(
			"estructura",
			"Ha entrado en el menú de Estructura."
		);
		//*** Fin del log ***
	}

	openModalTutorial() {
		if (this.isNavigating) return;
		this.isNavigating = true;
		setTimeout(() => { this.isNavigating = false }, 300);
		this.modalService.open(ModalTutorialManagerComponent, {
			scrollable: false,
			windowClass: MODAL_DIALOG_TYPES.W90,
		});
	}

	openModalDenuncias() {
		this.toastrService.show(
			this.translateService.instant('DENUNCIAR.DEACTIVATED'),
			'',
			{ status: 'warning' }
		);
	}

	//=========================================================
	//========== FUNCIONES BOTONES INFORMES ========== 
	//roles: editores = 1, alumnos = 2, profesores = 3, padres = 4

	verInforme(role: number, consulta: number) {
		if (this.isNavigating) return;
		this.isNavigating = true;
		setTimeout(() => { this.isNavigating = false }, 300);

		const modalRef = this.modalService.open(InformeAdminComponent,
			{
				scrollable: true,
				windowClass: MODAL_DIALOG_TYPES.W90,
			}
		);
		// No pasamos allDatasets, dejamos que el componente las cargue
		modalRef.componentInstance.consulta = consulta;
		modalRef.componentInstance.role = role;
		modalRef.result.then((result: string) => {
		});
	}

	openResumenActivity(role: number) {
		if (this.isNavigating) return;
		this.isNavigating = true;
		setTimeout(() => { this.isNavigating = false }, 300);
		this.modalService.open(ModalResumenActivityComponent, {
			scrollable: false,
			windowClass: MODAL_DIALOG_TYPES.W90,
		});
	}

	openEditor() {
		if (this.isNavigating) return;
		this.isNavigating = true;
		setTimeout(() => { this.isNavigating = false }, 300);
		this.modalService.open(SecondStepAdminComponent, {
			scrollable: false,
			windowClass: MODAL_DIALOG_TYPES.W90,
		});
	}

	openInventarioMandos() {
		if (this.isNavigating) return;
		this.isNavigating = true;
		setTimeout(() => { this.isNavigating = false }, 300);
		this.modalService.open(InventarioMandosComponent, {
			scrollable: true,
			windowClass: `${MODAL_DIALOG_TYPES.W90} h-100`,
		});
		this.mastersService.createActivityHistory(
			"inventario_mandos",
			"Ha entrado en el inventario de mandos."
		);
	}

	openAiUsageStats() {
		if (this.isNavigating) return;
		this.isNavigating = true;
		setTimeout(() => { this.isNavigating = false }, 300);
		this.modalService.open(ModalAiUsageStatsComponent, {
			scrollable: true,
			windowClass: `${MODAL_DIALOG_TYPES.W95} h-100`,
		});
	}

	openEstudioCientifico() {
		if (this.isNavigating) return;
		this.isNavigating = true;
		setTimeout(() => { this.isNavigating = false }, 300);
		this.modalService.open(EstudioCientificoComponent, {
			scrollable: true,
			windowClass: `${MODAL_DIALOG_TYPES.W90} h-100`,
		});
		this.mastersService.createActivityHistory(
			"estudio_cientifico",
			"Ha entrado en Estudio Científico."
		);
	}

}
